import { useReducer, useRef } from "react";
import {
  companyNotificationReducer,
  initialState,
} from "./notification.reducer";
import { getNotifications, markNotificationAllRead, markNotificationAsRead } from "../api/notificationApi";

export const useCompanyNotificationsViewModel = () => {
  const [state, dispatch] = useReducer(
    companyNotificationReducer,
    initialState,
  );
  const lastParamsRef = useRef<any>({});

  const fetchNotifications = async (params: any = {}) => {
    lastParamsRef.current = params;
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      const resp = await getNotifications(params);
      const data = resp.data?.data ?? resp.data;
      const notifications = data.notifications || [];
      dispatch({ type: "SET_NOTIFICATION_DATA", payload: notifications });
      dispatch({ type: "SET_TOTAL", payload: data.total || 0 });
      const unreadCount =
        data.unread_count ?? notifications.filter((n: any) => !n.is_read).length;
      dispatch({ type: "SET_UNREAD", payload: unreadCount });
    } catch (error) {
      console.log(error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };
  const handleMarkAsRead = async (notificationId: string) => {
    try {
      await markNotificationAsRead(notificationId);
      await fetchNotifications(lastParamsRef.current);
    } catch (error) {
      console.log(error);
    }
  };

  const handleMarkAllRead = async () => {
    try {
      await markNotificationAllRead();
      await fetchNotifications(lastParamsRef.current);
    } catch (error) {
      console.log(error);
    }
  };
  return {
    state,
    dispatch,
    fetchNotifications,
    handleMarkAsRead,
    handleMarkAllRead
  };
};
